export const HourglassSvg = ({ className }) => (
  <svg
    className={className}
    width="14"
    height="14"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 1.75A.75.75 0 0 1 3.75 1h8.5a.75.75 0 0 1 0 1.5h-.5v1.38c0 .9-.39 1.76-1.07 2.35L8.53 8l2.15 1.77c.68.59 1.07 1.45 1.07 2.35V13.5h.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1 0-1.5h.5v-1.38c0-.9.39-1.76 1.07-2.35L7.47 8 5.32 6.23A3.1 3.1 0 0 1 4.25 3.88V2.5h-.5A.75.75 0 0 1 3 1.75Zm2.75.75v1.38c0 .46.2.9.55 1.2L8 6.6l1.7-1.52c.35-.3.55-.74.55-1.2V2.5h-4.5Zm0 11v-1.38c0-.46.2-.9.55-1.2L8 9.4l1.7 1.52c.35.3.55.74.55 1.2v1.38h-4.5Z"
      fill="currentColor"
    />
  </svg>
);
